import service from "../../services/gestionTiempos/changeSchedule";

export default {
  namespaced: true,
  state: {
    service: new service(),
    date: null,
    schedule: [],
    new: {},
    deleteItem: {},
    editItems: [],
    segment: [],
    scheduleId: null,
    segmId: null,
    numsequence: [],
    changeSchedule: {
      from: null,
      schedule: null,
      to: null,
      initialSegment: null,
      initialDay: null,
      sequenceNumber: null,
    },
    employedSchedule: [],
    groupSchedule: [],
    segmentId: null,
    scheduleElement: [],
    stateDay: [],
    itemStateDay: {},
  },
  mutations: {
    setSchedule(state, data) {
      state.schedule = data;
    },
    setNew(state, data) {
      state.new = data;
    },
    setDeleteItem(state, data) {
      state.deleteItem = data;
    },
    setEdit(state, options) {
      state.editItems = options;
    },
    setSegment(state, data) {
      state.segment = data;
    },
    setScheduleId(state, data) {
      state.scheduleId = data;
    },
    setSegmId(state, data) {
      state.segmId = data;
    },
    setSequence(state, data) {
      state.numsequence = data;
    },
    setChangeSchedule(state, data) {
      state.changeSchedule = data;
    },
    setDate(state, data) {
      state.date = data;
    },
    setEmployedSchedule(state, data) {
      state.employedSchedule = data;
    },
    setGroupSchedule(state, data) {
      state.groupSchedule = data;
    },
    setSegmentId(state, data) {
      state.segmentId = data;
    },
    setScheduleElement(state, data) {
      state.scheduleElement = data;
    },
    setStateDay(state, data) {
      state.stateDay = data;
    },
    setItemStateDay(state, data) {
      state.itemStateDay = data;
    },
  },
  actions: {
    async getSegment({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          let data = state.scheduleId;
          let item = await state.service.getSegment(data);
          commit("setSegment", item);
          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async getSchedules({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          let item = await state.service.getSchedule();
          commit("setSchedule", item);
          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async getSequence({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          let item = await state.service.getNumberSec(
            state.scheduleId,
            state.segmId,
          );
          commit("setSequence", item);
          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },

    async getChangeSchedule({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service.new(state.new).then(() => {
            let options = state.changeSchedule;
            commit("setChangeSchedule", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async getEmployedSchedule({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          let item = await state.service.getEmployedSchedule();
          commit("setEmployedSchedule", item);
          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async getGroupSchedule({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          let item = await state.service.getGroupSchedule();
          commit("setGroupSchedule", item);
          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async delete({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service.delete(state.deleteItem).then(() => {
            const deleteitem = state.deleteItem;
            commit("setDeleteItem", deleteitem);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async edit({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          let item = await state.service.edit(state.editItems);
          commit("setEdit", { item });
          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async getScheduleElement({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          let item = await state.service.getScheduleElement(state.segmentId);
          commit("setScheduleElement", item);
          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async getStateDay({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          let item = await state.service.getStateDay(state.itemStateDay);
          commit("setStateDay", item);
          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
  },
};
